<script>
    import { onMount } from 'svelte'
    import { params, afterPageLoad } from '@sveltech/routify'
    import { crossfade } from 'svelte/transition'
    import { quintOut } from 'svelte/easing'
    import { flip } from 'svelte/animate'
    import { indexShow } from '../store.js'
    import { flyModified } from '../js/transitions.js'
    import CircuitMenu from './menu/CircuitMenu.svelte'
    import PageContent from './pages/PageContent.svelte'
    import PublicationsContent from './pages/PublicationsContent.svelte'
    import NewsContent from './pages/NewsContent.svelte'
    import PeopleContent from './pages/PeopleContent.svelte'
    import ResourcesContent from './pages/ResourcesContent.svelte'
    import TeachingContent from './pages/TeachingContent.svelte'

    export let pages, slug, windowWidth

    let menuShow = windowWidth > 1000
    let menuBox
    let view = ''

    $: if ($indexShow) { menuShow = false }
    $: activePage = pages.find(page => page.title.toLowerCase().includes(`${slug}`))

    $: () => { view = activePage === undefined ? 'homeView' : 'pageView' }

    const [send, receive] = crossfade({
        duration: d => Math.sqrt(d * 200),

        fallback: (node, params) => {
            const style = getComputedStyle(node)
            const transform = style.transform === 'none' ? '' : style.transform

            return {
                duration: 400,
                easing: quintOut,
                css: t =>
                    `transform: ${transform} scale(${t}); 
                    opacity: ${t};
                    height: ${t * 100}%;`
            }
        }
    })

    function toggleMenuShow () {
        menuShow = !menuShow
        document.querySelector('.tab svg').style.transform = menuShow
            ? 'rotate(0deg)'
            : 'rotate(180deg)'
    }
</script>

{#if windowWidth < 1000 && typeof activePage !== 'undefined' && !$indexShow}
    <div class="tabContainer">
        <div
            class="tab"
            on:click={toggleMenuShow}
            style="--pageColor:{activePage.circuit_color}"
        >
            <svg
                style="fill: white;"
                class="indicator"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 240.58 393.15"
            >
                <polygon points="240.58 196.58 0 393.15 0 0 240.58 196.58" />
            </svg>
        </div>
    </div>
{/if}

{#if (typeof activePage === 'undefined')}
    <div
        id="homeMenu"
        class="homeView"
        out:flyModified={{ y: 10, duration: 400, position: 'absolute' }}
    >
        <div id="homeMenuInner">
            {#each pages.filter(page => page.meta.type != 'one off page') as page (page.title)}
                <div class="linkwrapper flex"
                    in:receive={{ key: page.title }}
                    out:send={{ key: page.title }}
                >
                    <CircuitMenu bind:menuShow {page} sectionView={false} />
                </div>
            {/each}
        </div>
    </div>
{:else}
    <div id="pageSidebarMenu" class:menuShow style="--pageColor:{activePage.circuit_color}">
        {#each pages.filter(page => page.title.toLowerCase().includes(slug)) as page (page.title)}
            <div class="linkwrapper"
                in:receive={{ key: page.title }}
                out:send={{ key: page.title }}
            >
                <CircuitMenu bind:menuShow page={activePage} sectionView={true} />
            </div>
        {/each}
    </div>

    {#if (activePage.title == 'Teaching')}
        <TeachingContent page={activePage} />
    {:else if (activePage.title == 'Resources')}
        <ResourcesContent page={activePage} />
    {:else if (activePage.title == 'Publications')}
        <PublicationsContent page={activePage} />
    {:else if (activePage.title == 'News')}
        <NewsContent page={activePage} />
    {:else if (activePage.title == 'People')}
        <PeopleContent page={activePage} />
    {:else if (typeof activePage !== 'undefined' && activePage.title != 'Publications')}
        <PageContent page={activePage} />
    {/if}
{/if}

<style lang="scss">
    @import "../styles/vars";
    .linkwrapper {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        display: inline-block;
        text-decoration: none;
        color: black;
    }
    .flex {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    #homeMenu {
        width: 90%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 5%;
        overflow: hidden;
        display: flex;
        align-items: center;
        #homeMenuInner {
            width: 100%;
            display: grid;
        }
    }

    #pageSidebarMenu {
        position: fixed;
        overflow: visible;
        left: 50px;
        width: 20vw;
        top: 155px;
        .linkwrapper {
            max-width: unset;
            width: 100%;
        }
    }

    #pageSidebarMenu > .linkwrapper {
        position: absolute;
    }

    @include respond-to(computer) {
        #homeMenu {
            bottom: 15px;
        }

        #homeMenuInner {
            grid-template-columns: 1fr 1fr 1fr;
        }

        .linkwrapper {
            height: calc(44vh - 44px);
        }
    }
    @include respond-to(phone) {
        #homeMenuInner {
            grid-template-columns: 1fr 1fr;
        }

        .linkwrapper {
            height: calc(28vh - 28px);
            width: 100%;
            max-width: unset;
        }

        #pageSidebarMenu {
            background-color: rgba(250, 250, 250, 0.95);
            border: 2px solid var(--pageColor);
            box-sizing: border-box;
            position: fixed;
            top: 90px;
            left: 100%;
            width: 94vw;
            padding: 0 6vw 0 10vw;
            overflow: hidden;
            transition: left 1s ease;
            z-index: 4;
            padding-bottom: 20px;

            &.menuShow {
                left: 3vw;
            }
        }

        .tabContainer {
            position: fixed;
            right: 4rem;
            top: 0;
            height: 68px;
            display: flex;
            align-items: center;
            z-index: 10;
        }

        .tab {
            height: 30px;
            box-sizing: border-box;
            width:30px;
            padding-left: 7px;
            text-align: left;
            background-color: var(--pageColor);
            opacity: 1;
            font-family: "Work Sans", Helvetica;
            font-weight: 600;
            color: white;
            display: flex;
            align-items: center;
            z-index: 10;

            svg {
                height: 15px; width: 15px;
                transform: rotate(180deg);
                transition: transform 0.5s ease;
            }

            &:hover {
                cursor: pointer;
            }
        }
    }
</style>
